export default "__VITE_ASSET__DsAelw8u__ 960w, __VITE_ASSET__rRbfCHq7__ 1440w";